import { TEntityInfo } from '@/interfaces'
import { FormState } from '@/state'
import { formStateActions } from '@/state/actions'
import { Button } from 'antd'
import { ApplicationsState } from '@/state'

export default function RenderEntityOption({
  entity,
  index,
}: {
  entity: TEntityInfo
  index: number
}) {
  const handleSetCurrentEntity = () => formStateActions.setCurrentEntity(entity)

  const entityLabel = `${index} ${entity.label?.split(' ').slice(1).join(' ') || entity.name}`

  const entityActive = FormState.currentEntity.value?.name === entity.name

  // Detectar si la postulación está inhabilitada
  const isInhabilitado = ApplicationsState.currentApplication.value?.estadoName === 'INHABILITADO'
  // Detectar si la pestaña es Núcleo Familiar u Observación (ajustar el nombre según corresponda en entity.name o entity.label)
  const isNucleoFamiliar = entity.name?.toLowerCase().includes('CNucleoFamiliar') || entity.label?.toLowerCase().includes('núcleo')
  const isObservacion = entity.name?.toLowerCase().includes('CObservacion') || entity.label?.toLowerCase().includes('observación')

  return (
    <Button
      className={`entity-btn-option ${entityActive ? 'active' : ''}`}
      onClick={handleSetCurrentEntity}
      disabled={isInhabilitado && (isNucleoFamiliar || isObservacion)}
    >
      {entityLabel}
    </Button>
  )
}
